import React from "react";

const WA_HREF =
  "https://wa.me/436602903054?text=Hallo%2C%20ich%20interessiere%20mich%20für%20eine%20Anfrage";

export default function WhatsAppButton() {
  return (
    <a
      href={WA_HREF}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full grid place-items-center bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110 wa-pulse"
    >
      <svg
        viewBox="0 0 32 32"
        width="28"
        height="28"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.27c-.27-.13-1.59-.78-1.83-.87-.25-.09-.43-.13-.6.13-.18.27-.69.86-.85 1.04-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.6-1.5-1.86-.16-.27-.02-.41.12-.54.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.83-1.99-.22-.52-.44-.45-.6-.45-.16-.01-.34-.01-.52-.01-.18 0-.47.07-.71.34-.25.27-.94.92-.94 2.24 0 1.32.96 2.6 1.1 2.78.13.18 1.9 2.91 4.6 4.08.64.28 1.14.45 1.53.57.64.2 1.23.18 1.69.11.52-.08 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.25-.18-.52-.31zM16.03 5.33c-5.91 0-10.71 4.8-10.71 10.71 0 1.89.5 3.74 1.45 5.37l-1.54 5.6 5.74-1.5c1.57.86 3.34 1.31 5.06 1.31 5.91 0 10.71-4.8 10.71-10.71S21.95 5.33 16.03 5.33zm0 19.61c-1.55 0-3.07-.42-4.39-1.21l-.31-.18-3.41.89.91-3.32-.2-.32a8.78 8.78 0 0 1-1.36-4.76c0-4.85 3.95-8.8 8.8-8.8 4.85 0 8.8 3.95 8.8 8.8 0 4.85-3.95 8.8-8.84 8.8z" />
      </svg>
    </a>
  );
}
